import icons from '@/components/svg'

export default {
  colors: {
    primary: '#528ef7',
    secondary: '#101e3e',
    error: '#FF726D',
    accent: '#FF726D',
    'osg-gray': '#828282',
    'osg-gray-1': '#474747',
    'osg-gray-2': '#7A7A7A',
    'osg-gray-3': '#FAFAFA',
    'osg-black': '#2a2a2a',
    'osg-active': '#e7effe',
    'osg-active-border': '#e7effe',
    'osg-active-font': '#528ef7',
    'osg-active-icon': '#1f3261',
    'osg-active-text': '#1f3261',
    'osg-gray-text': '#4f4f4f',
    'primary-blue': '#e4f0ff',
    'negative-number': '#EE555A',
    'osg-red-1': '#FF726D',
    'osg-red-2': '#FFE6E5',
    'osg-red-3': '#EE555A',
    'osg-blue': '#26499F',
    'osg-blue-2': '#3E8DFF',
    'osg-green': '#08B192',
    'osg-yellow': '#F3BF58'
  },
  icons: {
    'osg-logo': {
      component: icons.OsiguLogo
    },
    'osg-website': {
        component: icons.WebsiteIcon
    },
    'osg-instagram': {
      component: icons.InstagramIcon
    },
    'osg-linkedin': {
      component: icons.LinkedInIcon
    },
    'osg-chat': {
      component: icons.ChatIcon
    },
    'osg-error': {
      component: icons.ErrorIcon
    },
    'osg-email': {
      component: icons.EmailIcon
    },
    'osg-shield': {
      component: icons.ShieldIcon
    },
    'osg-profile': {
      component: icons.ProfileIcon
    },
    'osg-download': {
      component: icons.DownloadIcon
    },
    'osg-refresh-primary': {
      component: icons.RefreshIconPrimary
    },
    'osg-refresh-white': {
      component: icons.RefreshIconWhite
    },
    'osg-refresh-disabled': {
      component: icons.RefreshIconDisabled
    },
    'osg-download-disabled': {
      component: icons.DownloadIconDisabled
    },
    'osg-dashboard': {
      component: icons.DashboardIcon
    },
  }
}
